import { render } from "./menu-avatar.vue?vue&type=template&id=64291133&ts=true"
import script from "./menu-avatar.vue?vue&type=script&lang=ts"
export * from "./menu-avatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__